import React from "react";
import "./SizeGuide.css"; // Estilos específicos para este componente

function SizeGuide({ measurements })  
{
  if (!measurements || measurements.length === 0) {
    return <p>No hay guía de tallas disponible.</p>;
  }

  return (
    <div className="size-guide-container">
      <h4>Guía de Tallas</h4>
      <table className="size-guide-table">
        <thead>
          <tr>
            <th>Talla</th>
            <th>Busto (cm)</th>
            <th>Cintura (cm)</th>
            <th>Caderas (cm)</th>
          </tr>
        </thead>
        <tbody>
          {measurements.map((measurement, index) => (
            <tr key={index}>
              <td>{measurement.size}</td>
              <td>{measurement.bust}</td>
              <td>{measurement.waist}</td>
              <td>{measurement.hips}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export { SizeGuide };
